import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '../lib/utils';

export const FloatingWhatsApp = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== 'undefined') {
        if (window.scrollY > lastScrollY && window.scrollY > 100) {
          // if scroll down
          setIsVisible(true);
        } else {
          // if scroll up
          setIsVisible(false);
        }

        // remember current page location to use in the next move
        setLastScrollY(window.scrollY);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavbar);

      // cleanup function
      return () => {
        window.removeEventListener('scroll', controlNavbar);
      };
    }
  }, [lastScrollY]);

  // Logic: Dynamic number based on the page
  const getPhoneNumber = () => {
    // Frostella (Pickles or Desserts)
    if (pathname.includes('frostella')) {
      return '919497227813';
    }
    // Prime Learn
    if (pathname.includes('prime-learn')) {
      return '918301062075';
    }
    //Kalyan Agencies
    if (pathname.includes('kalyan-agencies')) {
      return '918075887813';
    }
    //Medcity
    if (pathname.includes('medcity')) {
      return '917025865774';
    }
    // Default Group Number
    return '917025865774';
  };

  const phoneNumber = getPhoneNumber();

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.a
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          href={`https://wa.me/${phoneNumber}`}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            "fixed bottom-6 right-6 z-50",
            "flex items-center justify-center",
            "w-14 h-14 md:w-12 md:h-12",
            "bg-[#25D366] text-white rounded-full shadow-2xl",
            "border border-white/20 backdrop-blur-xl",
            "group transition-all duration-500",
            "hover:shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:bg-[#20bd5a]"
          )}
          aria-label="Chat on WhatsApp"
        >
          {/* Animated Glow Background */}
          <div className="absolute inset-0 bg-white/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

          {/* Icon & Indicator Wrapper */}
          <div className="relative z-10">
            <MessageCircle className="w-6 h-6 md:w-6 md:h-6 text-white transition-colors duration-300" />

            {/* Online Status Indicator */}
            <span className="absolute -top-0 -right-0 flex h-2.5 w-2.5 md:h-2.5 md:w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 md:h-2.5 md:w-2.5 bg-white"></span>
            </span>
          </div>

          {/* Label */}
          <span className={cn(
            "absolute right-full mr-4 px-4 py-2 rounded-xl",
            "bg-white/90 backdrop-blur-md border border-neutral-200",
            "text-primary text-sm font-display font-bold tracking-wide",
            "shadow-xl opacity-0 -translate-x-4 pointer-events-none",
            "group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300",
            "whitespace-nowrap hidden md:block"
          )}>
            Chat with us
            <div className="absolute top-1/2 -right-1 -translate-y-1/2 w-2 h-2 bg-white/90 border-r border-t border-neutral-200 rotate-45" />
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};